module.exports = __webpack_public_path__ + "img/bayer.5c9fc580.png";